// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"pY-z","subtitle":"qY-z","wrapper":"rY-z","leftArrow":"sY-z","rightArrow":"tY-z"};